import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { Button } from "semantic-ui-react";
import PropTypes from "prop-types";
import "../styles/MyUrbanimmersiveLoginAd.less";

@observer
class MyUrbanimmersiveLoginAd extends Component {
  render() {
    const { t } = this.props;

    return (
      <div className="ad my-urbanimmersive">
        <h2 className="login-ad-heading">
          {t("login:discover")} <strong>{t("login:dollhouse")}</strong>
        </h2>
        <h2>{t("login:nowAvailable")}</h2>
        <div className="computer layout">
          <video
            className="video"
            src="https://storage.googleapis.com/biz-website/videos/tb_login_ad_discover.mp4"
            playsInline
            autoPlay
            muted
            loop
            poster="/assets/images/login_video_uimeet3d_poster.jpg"
          />
        </div>
        <div className="login-ad-action-btn">
          <Button.Group compact>
            <Button href="https://www.tourbuzz.com/pricing" target="_blank">
              {t("login:pricingDetails")}
            </Button>
            <Button primary href="https://www.tourbuzz.com/3d_tour" target="_blank">
              {t("login:learnMore")}
            </Button>
          </Button.Group>
        </div>
        <p className="login-ad-disclaimer">{t("login:forResidentialOnlyCommercialPricing")}</p>
      </div>
    );
  }
}

MyUrbanimmersiveLoginAd.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(MyUrbanimmersiveLoginAd);
